// ProfileSummary.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { getNodeSubtitle } from 'utilities/NodeSubtitle';

// CSS
import './ProfileSummary.css';

/**
 * ProfileSummary
 *
 * Displays a single reply/profile in list format.
 * Shows author, subject (with Re: for replies), and date.
 * 
 * @param {object} node - The profile node to display.
 * @param {Function} onClick - Click handler.
 * @param {boolean} focused - Whether the summary is focused.
 * 
 * @returns {ReactNode} The rendered component.
 */
const ProfileSummary = ({ node, onClick, focused }) => {

  // ----- CONTEXT ----- //

  const { theme } = useTheme();

  // ----- STATE ----- //

  const [hovered, setHovered] = useState(false);

  // Helpers
  function initials(name) {
    const parts = String(name || '').trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => (p[0]?.toUpperCase?.() || '')).join('') || 'A';
  }

  if (!node) return null;

  // ----- RENDER ----- //

  return (
    <div
      className={`profile-summary-container${focused ? ' focused' : ''}`}
      style={{
        backgroundColor: focused
          ? theme.backgroundHover
          : hovered
            ? theme.backgroundMuted
            : 'transparent',
      }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

      {/* LEFT SECTION */}
      <div className="profile-summary-left">

        {/* AVATAR */}
        <div
          className="profile-summary-avatar"
        >
          {initials(node?.user?.name)}
        </div>

        {/* AUTHOR / PARENT */}
        <div className="profile-summary-center-left">

          {/* NAME */}
          <div
            className="profile-summary-name"
          >
            {node?.user?.name}
          </div>
          {/* DESCRIPTION */}
          <div
            className="profile-summary-description"
          >
            {getNodeSubtitle(node)}
          </div>
        </div>
      </div>

    </div>
  );
};

// Dev Tools
ProfileSummary.displayName = 'ProfileSummary';

export default ProfileSummary;
